import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfSaskatchewan = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Saskatchewan"
      universityShortName="USask"
      slug="university-of-saskatchewan"
      seoTitle="University of Saskatchewan Study Rooms | Saskatoon Campus Study Guide"
      seoDescription="Complete guide to study rooms at University of Saskatchewan. Find Murray Library, Low-Sensory Room, and noise-zoned spaces. Plus free 24/7 online alternative."
      seoKeywords="university of saskatchewan study rooms, usask library, murray library, saskatoon university study spaces, low sensory study room"
      canonicalUrl="/study-room/university-of-saskatchewan/"
      heroDescription="A comprehensive guide to study rooms at USask, including noise-categorized spaces and the unique Low-Sensory Study Room."
      libraryWebsiteUrl="https://library.usask.ca/"
      libraryWebsiteName="USask Library"
      studySpaces={[
        {
          name: "Conversational Zones",
          features: "Designated for group work with normal conversation levels.",
          feedback: "Great for collaborative projects; can get lively during peak hours."
        },
        {
          name: "Considerate Zones",
          features: "For quiet group work with lower noise levels.",
          feedback: "Good balance between collaboration and quiet."
        },
        {
          name: "Quiet Zones",
          features: "Individual silent study areas.",
          feedback: "Enforced quiet for focused work."
        },
        {
          name: "Bookable Study Rooms",
          features: "Rooms with screens in all libraries; up to two sessions per week, two hours each.",
          feedback: "Not soundproof so voices carry; only two bookings per week can be limiting."
        },
        {
          name: "Low-Sensory Study Room (Murray Library)",
          features: "Sound-dampening panels, adjustable lighting, and comfortable seating for students who need minimal distractions.",
          feedback: "Highly appreciated for its inclusive design; unique resource."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Use the <strong>Murray Library's Low-Sensory Room</strong> when you need to minimize distractions. Book group rooms early and keep voices down—sound carries through walls.
          </p>
          <p className="mb-4">
            For late-night study, check the <strong>Murray and Law libraries</strong>, which offer extended hours.
          </p>
          <p>
            Many appreciate the clear noise zones and the inclusive low-sensory room, but note that only two bookings are allowed per week.
          </p>
        </>
      }
      summaryTips={[
        "Try the Low-Sensory Room: Sound-dampening panels and adjustable lighting for minimal distractions.",
        "Choose your noise zone: Conversational, Considerate, or Quiet based on your needs.",
        "Keep voices down in group rooms: Walls are not soundproof.",
        "Plan bookings carefully: Only two sessions per week allowed.",
        "Use CSW for unlimited sessions: No booking limits in virtual study rooms."
      ]}
    />
  );
};

export default UniversityOfSaskatchewan;
